import "./ProdutoPreco.css";

export default function ProdutoPreco({
    mostrarPreco,
    ehCNPJ,
    produto,
    caixa,
    pesoPorPeca,
    valorCaixa,
    valorPeca,
    
}) {

    return (
    <div className="produtoPreco-container">

        {!mostrarPreco ? (

            <div className="produtoPreco-borrado">

                <span className="produtoPreco-cifrao">
                    R$
                </span>

                <span className="produtoPreco-valorBorrado">
                    {Number(produto.precovenda).toFixed(2)}
                </span>

            </div>

        ) : (

            <>

                {ehCNPJ &&
                produto.valorunitario != null &&
                Number(produto.valorunitario) <
                    Number(produto.precovenda) ? (

                    <>

                        <div className="produtoPreco-antigo">
                            R$ {Number(produto.precovenda).toFixed(2)}
                        </div>

                        <div className="produtoPreco-desconto">
                            R$ {Number(produto.valorunitario).toFixed(2)}
                            {(caixa || pesoPorPeca) && " / kg"}
                        </div>

                    </>

                ) : (

                    <div className="produtoPreco-normal">
                        R$ {Number(produto.precovenda).toFixed(2)}
                        {(caixa || pesoPorPeca) && " / kg"}
                    </div>

                )}

                {caixa && (

                    <div className="produtoPreco-extra">
                        Valor da caixa: R$ {valorCaixa.toFixed(2)}
                    </div>

                )}

                {pesoPorPeca && (

                    <div className="produtoPreco-extra">
                        Valor da peça: R$ {valorPeca.toFixed(2)}
                    </div>

                )}

            </>

        )}

    </div>
);
}